import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import UserTopbar from "../../features/manageUsers/topbar";
import UserList from "../../features/manageUsers/userList";
import { useGetUsersQuery } from "../../service/features/api";
import { Box, Tab, Tabs, Button } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import AddIcon from '@mui/icons-material/Add';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DealerList from "../../features/manageDealers/dealerList";
import { useGetShowroomsQuery, useExportShowroomsMutation } from "../../service/showroom/api";
import React from "react";
import { toast } from "react-toastify";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageUser = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [dealerSearchTerm, setDealerSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [dealerPage, setDealerPage] = useState(1);
  const [valueTabs, setValueTabs] = React.useState(0);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  useEffect(() => {
    setPage(1);
  }, [searchTerm]);

  useEffect(() => {
    setDealerPage(1);
  }, [dealerSearchTerm]);

  const { data, isLoading } = useGetUsersQuery({ page, limit: 10, search: searchTerm });
  const responseData = data?.data || {};
  const users = responseData.docs || [];
  const totalDocs = responseData.totalDocs || 0;
  const limit = responseData.limit || 10;
  const paginator = {
    itemCount: totalDocs,
    pageCount: Math.ceil(totalDocs / limit),
  };

  const { data: dealerData, isLoading: isDealerLoading } = useGetShowroomsQuery({ page: dealerPage, limit: 10, search: dealerSearchTerm });
  const dealerShowrooms = dealerData?.data?.data || [];
  const dealerPaginator = dealerData?.data?.paginator || null;

  const [exportShowrooms, { isLoading: isExportingShowrooms }] = useExportShowroomsMutation();

  const handleShowroomExport = async () => {
    try {
      const res = await exportShowrooms({}).unwrap();
      if (res?.data?.fileUrl) {
        window.open(res.data.fileUrl, "_blank");
        toast.success(res?.message || "SHOWROOM_CSV_GENERATED_SUCCESSFULLY");
      }
    } catch (error: any) {
      toast.error(error?.data?.message || "Failed to export showrooms");
    }
  };

  return (
    <>
      <CommonBreadcrumb
        title={valueTabs === 0 ? "إدارة العملاء / Customer Management" : "إدارة المعارض / Showrooms Management"}
        breadcrumbItems={[
          { label: "لوحة المعلومات / Dashboard", onClick: () => navigate("/dashboard") },
          { label: valueTabs === 0 ? "إدارة العملاء / Customer Management" : "إدارة المعارض / Showrooms Management" },
        ]}
      />

      <Box className="custom_tabs1" sx={{ width: "100%", mb: 3 }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          className="custom_tabs_links"
        >
          <Tab label="إدارة العملاء / Customer Management" {...a11yProps(0)} />
          <Tab label="إدارة المعارض / Showrooms Management" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTabs} index={0}>
        <div className="cards">
          <UserTopbar searchTerm={searchTerm} setDebouncedSearchTerm={setSearchTerm} />
          <UserList
            users={users}
            page={page}
            setPage={setPage}
            paginator={paginator}
            isLoading={isLoading}
          />
        </div>
      </CustomTabPanel>

      <CustomTabPanel value={valueTabs} index={1}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={dealerSearchTerm}
                setDebouncedSearchTerm={setDealerSearchTerm}
                placeholder="بحث المعارض / Search Showroom"
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={handleShowroomExport}
                disabled={isExportingShowrooms}
              >
                {isExportingShowrooms ? "Exporting..." : <><FileDownloadOutlinedIcon /> تصدير CSV / Export CSV</>}
              </Button>
              <Button className="btn btn_primary" onClick={() => navigate('/manage-dealers/add')}><AddIcon /> إضافة معرض / Add Showroom</Button>
            </div>
          </div>
          <DealerList
            showrooms={dealerShowrooms}
            page={dealerPage}
            setPage={setDealerPage}
            paginator={dealerPaginator}
            isLoading={isDealerLoading}
          />
        </div>
      </CustomTabPanel>
    </>
  );
};

export default ManageUser;

